import { render } from "./MessagingPage.vue?vue&type=template&id=3d35f430"
import script from "./MessagingPage.vue?vue&type=script&lang=js"
export * from "./MessagingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__